import {
  AndroidFilled, AppleFilled,
  DownloadOutlined,
  DownOutlined,
  ReloadOutlined,
  SettingOutlined,
  UploadOutlined
} from "@ant-design/icons";
import { getOrgsOptionsSelector, treeNode } from "@redux/selector";
import {
  Badge,
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  Dropdown,
  Empty,
  Form, FormInstance,
  Input,
  Menu,
  Modal,
  notification,
  Pagination,
  Popconfirm,
  Row,
  Select,
  Space,
  Spin,
  Table,
  Upload
} from "antd";
import dayjs from 'dayjs';
import React from "react";
import { connect } from "react-redux";
import { NavLink, RouteComponentProps } from "react-router-dom";
import {
  getAccount,
  getTagList,
  getAccountPlatforms
} from "../../axios/api.account";
import {
  addAndroidDevice,
  androidDeviceOperations,
  appDeviceTemplate,
  batchEditDevices,
  deleteAndroidDevice,
  exportDevices,
  getDeviceCounts,
  getDeviceFilter,
  getDevices,
  getTemplateListAll,
  iosDeviceOperations,
  updateDevicesShowColumns,
  updateDevicesOrders
} from "../../axios/api.device";
import { CancelTokenSource } from "../../axios/axios.core";
import { RootStoreModel } from "../../redux/reducers";
import { stringContaint } from "../../utils/common";
import { gaEvent } from "../../withTracker";
import {
  BasicStateForListModel,
  DeviceTypes
} from "../models";
import { DeviceForm } from "./device.add";
import "./device.scss";

import i18n from "@src/locales";
import { Translation } from "react-i18next";
import TextArea from "antd/lib/input/TextArea";

const CheckboxGroup = Checkbox.Group;
interface stateModel extends BasicStateForListModel {
  deviceFormRef: FormInstance<any> | null;
  isDeviceModalvisible: boolean;
  orgOptions: any[];
  //searchDeviceType: string | undefined;
  searchPlatform: string | undefined;
  tagList: any[],
  //selectTag: string[],
  tableDropdownVisible:boolean,
  tableColumns:any[],
  tableCheckColumes:string[],
  selectedRows: any[],
  selectedRowKeys: React.Key[],
  isBatchEdit: boolean,
  showTemplate: boolean,
  templateList: any[],
  selectTemplate: string,
  file: any,
  orderBy: string,
  order: string,
  selectedPlatform: string,
  platformCountMapping: any,
  selectedMenu: string,
  systemUpdateVisible: boolean,
  batchOperationVisible: boolean,
  eraseDeviceVisible: boolean,
  isLoseModaVisible: boolean,
  clearLock: boolean,
  columnFilters: any,
  tableColumnTem: any[],
  // defaultTableColumnTem: any[],
  templateColumns: any[],
  extras: any,
  selectAll : boolean
}

interface propsModel extends RouteComponentProps<any, any, any> {
  orgOptions: treeNode[],
  tokenSuccess: boolean
}

const mapStatetoProps = (state: RootStoreModel) => ({
  orgOptions: getOrgsOptionsSelector(state),
  tokenSuccess: state.userState.tokenSuccess
});

class DeviceListPage extends React.Component<propsModel, stateModel> {
  formRef = React.createRef<FormInstance>();
  lostformRef = React.createRef<FormInstance>();
  constructor(props: propsModel) {
    super(props);
    this.state = {
      pageIndex: 1,
      pageSize: 10,
      totalCount: 0,
      loading: false,
      columns: [],
      data: [],
      deviceFormRef: React.createRef<FormInstance>().current,
      isDeviceModalvisible: false,
      orgOptions: [],
      tagList: [],
      tableDropdownVisible:false,
      // tableColumns: defaultTableColumnTem,
      // tableCheckColumes: defaultTableColumnTem.map(e=>{return e.key}),
      tableCheckColumes: [],
      selectedRows: [],
      selectedRowKeys: [],
      isBatchEdit: false,
      searchPlatform: "IOS",
      showTemplate: false,
      templateList: [],
      selectTemplate: "",
      file: "",
      orderBy: "",
      order: "",
      selectedPlatform: "IOS",
      platformCountMapping: {},
      selectedMenu: "Device",
      systemUpdateVisible: false,
      batchOperationVisible: false,
      eraseDeviceVisible: false,
      isLoseModaVisible: false,
      clearLock: false,
      columnFilters: {},
      tableColumnTem: [],
      selectAll : false,
      tableColumns: [
        {
          title: '绑定状态',
          dataIndex: 'status',
          key: 'status',
          // width: 100,
          render:(v:any) => (
            <Translation>{t => {
              return <Badge color={v === 0 ? "red" : v === 1 ? "green" : "yellow"} text={v === 0 ? t("未绑定") : v === 3 ? t("待激活") : t("已绑定")} />
            }}</Translation>
          )
        },
        {
          title: '上次同步',
          dataIndex: 'unSyncDay',
          key: 'unSyncDay',
          // width: 200,
          sorter: true,
          showSorterTooltip: false,
          render: (v: any) => {
            return <>
              <Translation>{t => {
                return <Badge color={v === 0 ? "green" : "yellow"} text={v === 0 ? t("1 天内") : `${v} ${t("天前")}`} />
              }}</Translation>
            </>
          }
        },
        {
          title: '设备名称',
          dataIndex: 'deviceName',
          key: 'deviceName',
          width: 200,
          sorter: true,
          showSorterTooltip: false,
          defaultSortOrder: "ascend"
        },
        {
          title: '序列号',
          dataIndex: 'serialNo',
          key: 'serialNo',
          width: 200,
          sorter: true,
          showSorterTooltip: false,
        },
        {
          title: '设备类型',
          dataIndex: 'deviceType',
          key: 'deviceType',
          width: 100,
          sorter: true,
          showSorterTooltip: false,
          render: (v: any) => <Translation>{t => {return t(DeviceTypes[v])}}</Translation>
        },
        {
          title: '设备型号',
          dataIndex: 'model',
          key: 'model',
          width: 200,
          sorter: true,
          showSorterTooltip: false,
        },
        {
          title: '平台',
          dataIndex: 'platform',
          key: 'platform',
          width: 100,
          sorter: true,
          showSorterTooltip: false,
          render: (v: any) =>(<div >
          {v=="Android"&&(
            <span >< AndroidFilled style={{color:"#999999",fontSize:20}}/>&nbsp;&nbsp;Android</span>
          )}
          {v=="IOS"&&(
            <span><AppleFilled style={{color:"#999999",fontSize:20}}/>&nbsp;&nbsp;iOS</span>
          )}
           {v=="macOS"&&(
            <span><AppleFilled style={{color:"#999999",fontSize:20}}/>&nbsp;&nbsp;macOS</span>
          )}
          </div>)
        },
        {
          title: '用户',
          dataIndex: 'userName',
          key: 'userName',
          width: 100,
          sorter: true,
          showSorterTooltip: false,
        },
        {
          title: '例外',
          dataIndex: 'isExcluded',
          key: 'isExcluded',
          width: 100,
          sorter: true,
          // showSorterTooltip: false,
          render: (value: boolean) => {
            return <Translation>{t => {
              return value ? t("是") : t("否")
            }}</Translation>
          }
        },
        {
          title: '注册日期',
          dataIndex: 'enrollTime',
          key: 'enrollTime',
          width: 100,
          sorter: true,
          showSorterTooltip: false,
          render: (value: any) => dayjs(value).format("YYYY/MM/DD")
        },
        {
          title: '最近同步时间',
          dataIndex: 'syncSuccessTime',
          key: 'syncSuccessTime',
          width: 150,
          sorter: true,
          showSorterTooltip: false,
        },
        {
          title: '操作',
          dataIndex: 'id',
          key: 'id',
          fixed: 'right',
          width: 100,
          render: (v: any, row: any) => {
            return (
              <Translation>{t => {
                return <NavLink to={`/home/devices/details/${v}`}>{t("更多信息")}</NavLink>
              }}</Translation>
                // <NavLink to={{pathname: `/home/device/${v}`, state: {status: row.status}}}>{row.status === 3 ? "" : "更多信息"}</NavLink>
            );
          }
        },
      ],
      templateColumns: [
        {
          title: '配置文件名称',
          dataIndex: 'name',
          filterMultiple: false,
          key: 'name',
        },
        {
          title: '平台',
          dataIndex: 'platform',
          key: 'platform',
          render: (v: string) => {return v === "IOS" ? "iOS" : v}
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          key: 'createTime',
        },
      ],
      extras: null
    };
  }
  cancelToken = CancelTokenSource();
  async componentDidMount() {
    if (this.props.tokenSuccess) {
      await this.getPlatfrom();
      await this.getTagList();
      await this.getList();
    }

  }
  async componentDidUpdate(prevProps: propsModel) {
    if (this.props.tokenSuccess != prevProps.tokenSuccess) {
      await this.getPlatfrom();
      await this.getTagList();
      await this.getList();
    }
  }
  componentWillUnmount() {
    this.setState = () => { }
    this.cancelToken.cancel("cancel axios http request");
  }
  onSearch = () => {
    this.getList(1);
  };

  async getPlatfrom() {
    await getAccountPlatforms().then((res) => {
      this.setState({selectedPlatform: res, searchPlatform:res});
      this.formRef.current?.setFieldValue("platform",res);
    })
  }

   async getTagList() {
    getTagList().then((res: any) => {
      var arr = [];
      arr = res;
      var options = [];

      for (var i = 0; i < arr.length; i++) {
        if (arr[i].values) {
          for (var j = 0; j < arr[i].values.length; j++) {
            options.push(arr[i].values[j])
          }
        }
      }
      this.setState({ tagList: options })
    });
  }

  formatFilters = (filters: any) => {
    if (Object.keys(filters).length > 0) {
      let extras: any = {
        osVersions: filters?.osVersion || [],
        osUpdateStatuses: filters?.osUpdateStatus || [],
        orgs: filters?.organizationName || [],
        // tags: filters?.tagValues || [],
        adeOrgs: filters?.abmasm || [],
        adeAdmins: filters?.appleId || [],
        //singleAppModes: filters?.isSingleAppModeEnabled || [],
        singleAppModes: filters?.singleAppStatus || [],
      };
      Object.keys(extras).forEach(key => {
        // if (key === "tags") {
        //   // 反选
        //   let tmpTags = this.state.columnFilters[key].filter((item: any) => {
        //     return !extras[key].includes(item.value)
        //   });
        //   extras[key] = tmpTags.map((item: any) => item.value);
        // }
        if (extras[key]?.length === 0 || extras[key]?.length === this.state.columnFilters[key]?.length) {
          extras[key] = [];
        }
      });
      return extras;
    } else {
      return null
    }
  }

  getCount = async (key: string) => {
    const deviceCounts: any = await getDeviceCounts();
    const iOSCounts = !deviceCounts ? 0 : deviceCounts?.filter((item: any) => item.platform === "IOS" && (key === "Device" ? !item.recycleBin : item.recycleBin));
    const AndroidCounts = !deviceCounts ? 0 : deviceCounts?.filter((item: any) => item.platform === "Android" && (key === "Device" ? !item.recycleBin : item.recycleBin));
    const macOSCounts = !deviceCounts ? 0 : deviceCounts?.filter((item: any) => item.platform === "macOS" && (key === "Device" ? !item.recycleBin : item.recycleBin));

    this.setState({
      platformCountMapping: {
        IOS: (iOSCounts && iOSCounts.length > 0) ? iOSCounts[0].count : 0,
        Android: (AndroidCounts && AndroidCounts.length > 0) ? AndroidCounts[0].count : 0,
        macOS: (macOSCounts && macOSCounts.length > 0) ? macOSCounts[0].count : 0,
      }
    });
  }

  getList = async (
    pageIndex = this.state.pageIndex,
    pageSize = this.state.pageSize,
    extras = this.state.extras
  ) => {
    this.formRef?.current?.validateFields().then((res:any)=>{
      const {
        searchName,
        deviceType,
        searchOrg,
        tags,
        status,
      } = res;
      console.log(res);
      this.setState({ loading: true });
      getDevices({
        pageIndex,
        pageSize,
        search: searchName,
        deviceType: deviceType,
        status: this.state.selectedMenu === "Device" ? status : "4",
        platform: this.state.selectedPlatform,
        //platform: platform ? platform: this.state.platform,
        organizationId: searchOrg,
        orderBy: this.state.orderBy,
        order: this.state.order
      }, tags, extras).then(async (res) => {
        //await this.getCount(this.state.selectedMenu);
        //this.state.platformCountMapping[this.state.selectedPlatform] = res.totalCount;
        // if (!this.state.platformCountMapping["Android"]) {
        //   await getDevices({
        //     platform: "Android",
        //     pageIndex: 1,
        //     pageSize: 20,
        //     status: this.state.selectedMenu === "Device" ? status : "4",
        //   }, tags).then((res2) => {
        //     this.state.platformCountMapping["Android"] = res2.totalCount;
        //   })
        // }
        // if (!this.state.platformCountMapping["macOS"]) {
        //   await getDevices({
        //     platform: "macOS",
        //     pageIndex: 1,
        //     pageSize: 20,
        //     status: this.state.selectedMenu === "Device" ? status : "4",
        //   }, tags).then((res3) => {
        //     this.state.platformCountMapping["macOS"] = res3.totalCount;
        //   })
        // }

        const filterRes = await getDeviceFilter({
          platform: this.state.selectedPlatform,
          recycleBin: this.state.selectedMenu === "Device" ? false : true
        });
        filterRes["singleAppModes"] = [
          {value: "Enabled", name: <Translation>{t => {return t("已启用")}}</Translation>},
          {value: "Disabled", name: <Translation>{t => {return t("未启用")}}</Translation>},
          {value: "Pending", name: <Translation>{t => {return t("进行中")}}</Translation>},
        ]

        // const checkColumes = this.state.tableColumns.map(e => {return e.key});
        const tableColumnAll: any = [
          {
            title: '绑定状态',
            dataIndex: 'status',
            key: 'status',
            // width: 100,
            render:(v:any) => (
              <Translation>{t => {
                return <Badge color={v === 0 ? "red" : v === 1 ? "green" : "yellow"} text={v === 0 ? t("未绑定") : v === 3 ? t("待激活") : t("已绑定")} />
              }}</Translation>
            )
          },
          {
            title: '上次同步',
            dataIndex: 'unSyncDay',
            key: 'unSyncDay',
            // width: 200,
            sorter: true,
            showSorterTooltip: false,
            sortOrder: res.orderBy !== 'unSyncDay' ? null: res.order === 'asc' ? 'ascend' : 'descend',
            render: (v: any) => {
              return <>
              <Translation>{t => {
                return <Badge color={v === 0 ? "green" : "yellow"} text={v === 0 ? t("1 天内") : `${v} ${t("天前")}`} />
              }}</Translation>
              </>
            }
          },
          {
            title: '设备名称',
            dataIndex: 'deviceName',
            key: 'deviceName',
            width: 200,
            sorter: true,
            showSorterTooltip: false,
            sortOrder: res.orderBy !== 'deviceName' ? null: res.order === 'asc' ? 'ascend' : 'descend'
          },
          {
            title: '序列号',
            dataIndex: 'serialNo',
            key: 'serialNo',
            width: 200,
            sorter: true,
            showSorterTooltip: false,
            sortOrder: res.orderBy !== 'serialNo' ? null: res.order === 'asc' ? 'ascend' : 'descend'
          },
          {
            title: '设备类型',
            dataIndex: 'deviceType',
            key: 'deviceType',
            width: 100,
            sorter: true,
            showSorterTooltip: false,
            sortOrder: res.orderBy !== 'deviceType' ? null: res.order === 'asc' ? 'ascend' : 'descend',
            render: (v: any) => <Translation>{t => {return t(DeviceTypes[v])}}</Translation>
          },
          {
            title: '设备型号',
            dataIndex: 'model',
            key: 'model',
            width: 200,
            sorter: true,
            showSorterTooltip: false,
            sortOrder: res.orderBy !== 'model' ? null: res.order === 'asc' ? 'ascend' : 'descend'
          },
          {
            title: 'IMEI',
            dataIndex: 'imei',
            key: 'imei',
            width: 150,
            render: (value: string, item: any) => {
              var tmp = [];
              if (item.imei) {
                tmp.push(item.imei)
              }
              if (item.imeI2) {
                tmp.push(item.imeI2)
              }
              return tmp.join("，")
            }
          },
          {
            title: 'Bypass Code',
            dataIndex: 'bypassCode',
            key: 'bypassCode',
            width: 200,
          },
          {
            title: '平台',
            dataIndex: 'platform',
            key: 'platform',
            width: 100,
            sorter: true,
            showSorterTooltip: false,
            sortOrder: res.orderBy !== 'platform' ? null: res.order === 'asc' ? 'ascend' : 'descend',
            render: (v: any) =>(<div >
            {v=="Android"&&(
              <span ><AndroidFilled style={{color:"#999999",fontSize:20}}/>&nbsp;&nbsp;Android</span>
            )}
            {v=="IOS"&&(
              <span><AppleFilled style={{color:"#999999",fontSize:20}}/>&nbsp;&nbsp;iOS</span>
            )}
             {v=="macOS"&&(
              <span><AppleFilled style={{color:"#999999",fontSize:20}}/>&nbsp;&nbsp;macOS</span>
            )}
            </div>)
          },
          {
            title: '系统版本',
            dataIndex: 'osVersion',
            key: 'osVersion',
            width: 200,
            filters: filterRes["osVersions"].map((item: any) => {
              return {text: item.name, value: item.value}
            }),
            filteredValue: this.state.extras && this.state.extras["osVersions"],
            filterMode: 'tree',
            filterSearch: true,
            // onFilter: (value: string, record: any) => {
            //   console.log("=========value",value,record);
            //   return record.name.startsWith(value)
            // },
          },
          {
            title: '系统升级状态',
            dataIndex: 'osUpdateStatus',
            key: 'osUpdateStatus',
            width: 200,
            filters: filterRes["osUpdateStatuses"].map((item: any) => {
              return {text: item.name, value: item.value}
            }),
            filteredValue: this.state.extras && this.state.extras["osUpdateStatuses"],
            filterMode: 'tree',
            filterSearch: true,
          },
          {
            title: '用户',
            dataIndex: 'userName',
            key: 'userName',
            width: 100,
            sorter: true,
            sortOrder: res.orderBy !== 'userName' ? null: res.order === 'asc' ? 'ascend' : 'descend',
            showSorterTooltip: false,
          },
          // {
          //   title: '所属部门',
          //   dataIndex: 'organizationName',
          //   key: 'organizationName',
          //   width: 200,
          //   filters: filterRes["organizations"].map((item: any) => {
          //     return {text: item.name, value: item.value}
          //   }),
          //   filteredValue: this.state.extras && this.state.extras["organizations"],
          //   filterMode: 'tree',
          //   filterSearch: true,
          // },
          {
            title: '设备组',
            dataIndex: 'tagValues',
            key: 'tagValues',
            width: 200,
            // filters: filterRes["tags"].map((item: any) => {
            //   return {text: item.name, value: item.value}
            // }),
            // filterMode: 'tree',
            // filterSearch: true,
            render: (v: any) => {
              if (Array.isArray(v)) {
                return v.map(
                  (item, i) =>
                    `${item}${i < v.length - 1 ? "，" : ""}`
                );
              }
              return null;
            }
          },
          {
            title: '组织机构',
            dataIndex: 'abmasm',
            key: 'abmasm',
            width: 200,
            filters: filterRes["adeOrgs"].map((item: any) => {
              return {text: item.name, value: item.value}
            }),
            filteredValue: this.state.extras && this.state.extras["adeOrgs"],
            filterMode: 'tree',
            filterSearch: true,
          },
          {
            title: '机构管理员',
            dataIndex: 'appleId',
            key: 'appleId',
            width: 200,
            filters: filterRes["adeAdmins"].map((item: any) => {
              return {text: item.name, value: item.value}
            }),
            filteredValue: this.state.extras && this.state.extras["adeAdmins"],
            filterMode: 'tree',
            filterSearch: true,
          },
          {
            title: '例外',
            dataIndex: 'isExcluded',
            key: 'isExcluded',
            width: 100,
            sorter: true,
            sortOrder: res.orderBy !== 'isExcluded' ? null: res.order === 'asc' ? 'ascend' : 'descend',
            // showSorterTooltip: false,
            render: (value: boolean) => {
              return <Translation>{t => {
                return value ? t("是") : t("否")
              }}</Translation>
            }
          },
          {
            title: '注册日期',
            dataIndex: 'enrollTime',
            key: 'enrollTime',
            width: 100,
            sorter: true,
            showSorterTooltip: false,
            sortOrder: res.orderBy !== 'enrollDate' ? null: res.order === 'asc' ? 'ascend' : 'descend',
            render: (value: any) => dayjs(value).format("YYYY/MM/DD")
          },
          {
            title: '最近同步时间',
            dataIndex: 'syncSuccessTime',
            key: 'syncSuccessTime',
            width: 150,
            sorter: true,
            sortOrder: res.orderBy !== 'syncSuccessTime' ? null: res.order === 'asc' ? 'ascend' : 'descend',
            showSorterTooltip: false,
          },
          {
            title: '资产组',
            dataIndex: 'assetName',
            key: 'assetName',
            width: 150,
          },
          {
            title: '监督模式',
            dataIndex: 'supervisedModel',
            key: 'supervisedModel',
            width: 100,
            render: (item: any, row: any) => {
              return <Translation>{t => {
                return row?.iosDeviceInfo?.supervisedModel ? t("已启用") : t("未启用")
              }}</Translation>
            }
          },
          // {
          //   title: '丢失模式',
          //   dataIndex: 'isMDMLostModeEnabled',
          //   key: 'isMDMLostModeEnabled',
          //   width: 100,
          //   render: (item: any, row: any) => {
          //     return <Translation>{t => {
          //       return row?.iosDeviceInfo?.isMDMLostModeEnabled ? t("已启用") : t("未启用")
          //     }}</Translation>
          //   }
          // },
          {
            title: '丢失模式',
            dataIndex: 'lostModeStatus',
            key: 'lostModeStatus',
            width: 100,
            render: (item: any, row: any) => {
              return <Translation>{t => {
                if(row?.lostModeStatus == "Enabled")
                  return t("已启用");
                else if(row?.lostModeStatus == "Disabled")
                  return t("未启用");
                else if(row?.lostModeStatus == "Pending")
                  return t("进行中");
                else
                  return "";
                //return row?.iosDeviceInfo?.isMDMLostModeEnabled ? t("已启用") : t("未启用")
              }}</Translation>
            }
          },
          // {
          //   title: '单应用模式',
          //   dataIndex: 'isSingleAppModeEnabled',
          //   key: 'isSingleAppModeEnabled',
          //   width: 100,
          //   filters: filterRes["singleAppModes"].map((item: any) => {
          //     return {text: item.name, value: item.value}
          //   }),
          //   filteredValue: this.state.extras && this.state.extras["singleAppModes"],
          //   filterMode: 'tree',
          //   filterSearch: true,
          //   render: (v: boolean) => {
          //     return <Translation>{t => {
          //       return v ? t("已启用") : t("未启用")
          //     }}</Translation>
          //   }
          // },
          {
            title: '单应用模式',
            dataIndex: 'singleAppStatus',
            key: 'singleAppStatus',
            width: 100,
            filters: filterRes["singleAppModes"].map((item: any) => {
              return {text: item.name, value: item.value}
            }),
            filteredValue: this.state.extras && this.state.extras["singleAppModes"],
            filterMode: 'tree',
            filterSearch: true,
            render: (v: string) => {
              return <Translation>{t => {
                if(v == "Enabled")
                  return t("已启用");
                else if(v == "Disabled")
                  return t("未启用");
                else if(v == "Pending")
                  return t("进行中");
                else
                  return "";
                //return v ? t("已启用") : t("未启用")
              }}</Translation>
            }
          },
          {
            title: '设备拥有模式',
            dataIndex: 'isDeviceOwner',
            key: 'isDeviceOwner',
            width: 150,
            render: (item: any, row: any) => {
              return <Translation>{t => {
                return row?.androidDeviceInfo?.isDeviceOwner ? t("已启用") : t("未启用")
              }}</Translation>
            }
          },          
          {
            title: '备注',
            dataIndex: 'remark',
            key: 'remark',
            width: 150,
          },
          {
            title: '操作',
            dataIndex: 'id',
            key: 'id',
            fixed: 'right',
            width: 100,
            render: (v: any) => {
              return (
                <Translation>{t => {
                  return <NavLink to={`/home/devices/details/${v}`}>{t("更多信息")}</NavLink>
                }}</Translation>
              );
            }
          },
        ];

        this.filterColumns(res.columns, tableColumnAll);
        const { dataList } = res;
        this.setState({
          data: dataList.map((item, i) => ({ ...item, key: i })),
          pageSize: res.pageSize,
          pageIndex: res.pageIndex,
          loading: false,
          totalCount: res.totalCount,
          columnFilters: filterRes,
          // tableCheckColumes: checkColumes,
          tableColumnTem: tableColumnAll,
        });
      });
    })
  };
  onOk = () => {
    this.state.deviceFormRef?.validateFields().then(
      (res) => {
        const { account, owner, password, organization, tags } = res;
        const tagIds = Array.isArray(tags)
          ? tags
            .map((item) => {
              const tagObj = item?.tag || [];
              return tagObj.pop();
            })
            .filter((v) => v)
          : [];
        this.setState({ loading: true });
        addAndroidDevice({
          account,
          password,
          name: owner,
          organizationId: organization,
          tags: tagIds,
        }).then(
          () => {
            notification.success({ message: <Translation>{t => {return t("添加成功")}}</Translation> });
            this.setState(
              { loading: false, isDeviceModalvisible: false },
              () => {
                this.state.deviceFormRef?.resetFields();
              }
            );
            this.getList(1);
          },
          () => this.setState({ loading: false })
        );
      },
      () => { }
    );
    console.log(this.state.deviceFormRef);
  };
  onDelete = (id: string) => {
    this.setState({ loading: true });
    deleteAndroidDevice(id).then(
      () => {
        notification.success({ message: <Translation>{t => {return t("已删除")}}</Translation> });
        this.setState({ loading: false });
        this.getList(1);
      },
      () => this.setState({ loading: false })
    );
  };
  tableColumnsChange = (list: any) => {
    getAccount().then(res => {
      updateDevicesShowColumns(res.account, { platform: this.state.selectedPlatform, columns: list }).then(() => {
        this.filterColumns(list);
      })
    })
  }

  filterColumns = (list: any, columns=[]) => {
    var tabs = columns.length > 0 ? columns.filter((item: any) => {
      return list.findIndex((c: any) => c == item.key) != -1;
    }) : this.state.tableColumnTem.filter(item => {
      return list.findIndex((c: any) => c == item.key) != -1;
    });
    this.setState({ tableColumns: tabs, tableCheckColumes: list });
  }

  handleLoseOk = () => {
    this.lostformRef?.current?.validateFields().then(
      (res) => {
        const { phoneNumber, message } = res;
        this.setState({ loading: true });
        iosDeviceOperations({
          deviceIds: this.state.selectedRowKeys,
          commandType: 8,
          selectAll: this.state.selectAll,
          message: message,
          phoneNumber: phoneNumber
        }).then(
          () => { notification.success({message: <Translation>{t => {return t("操作成功")}}</Translation>});},
          () => { notification.error({message: <Translation>{t => {return t("操作失败")}}</Translation>}) },
        ).finally(
          () => { 
            this.setState({isLoseModaVisible: false, loading: false});
            this.refreshTable();
         }
        )
      },
      () => { }
    );
  };

  onSearchReset=()=>{
    this.formRef?.current?.resetFields();
  }

  onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    newSelectedRowKeys = this.state.selectedRows.map(item => item.id)
    this.setState({selectedRowKeys: newSelectedRowKeys});
  }

  rowSelection = () => {
    if (this.state.selectedMenu === "Device") {
      return {
        selectedRowKeys: this.state.selectedRowKeys,
        onChange: this.onSelectChange,
        // selections: [
        //   Table.SELECTION_ALL, Table.SELECTION_INVERT, Table.SELECTION_NONE
        // ],
        onSelect: (record: any, selected: any, selectedRows: any) => {
          if (selected) {
            this.state.selectedRows.push(record);
          }
          else {
            const delIndex =  this.state.selectedRows.findIndex((val: any) => val.id === record.id);
            this.state.selectedRows.splice(delIndex, 1);
          }
        },
        onSelectAll: (selected: any, selectedRows: any, changeRows: any) => {
          if (selected) {
            this.state.selectedRows.push(...changeRows);
          }
          else {
            changeRows.forEach((element: any) => {
              this.state.selectedRows.forEach((item: any, index: number) => {
                if (item.id === element.id) {
                  this.state.selectedRows.splice(index, 1);
                }
              })
            });
            // const delIndexs: any[] = [];
            // this.state.selectedRows.forEach((item: any, index: number) => {
            //   changeRows.forEach((element: any) => {
            //     if (item.id === element.id) {
            //       delIndexs.push(index)
            //     }
            //   })
            // });
            // delIndexs.forEach(val => {
            //   delete this.state.selectedRows[val];
            // })
            // this.setState({selectedRows: this.state.selectedRows.filter((item: any) => item !== undefined)});
          }
        },
        columnWidth: "50px",
      }
    } else {
      return 
    }
  }

  onChange = (e: any) => {
    this.setState({ selectAll: e.target.checked });
    console.log(`checked = ${e.target.checked}`);
  };

  refreshTable = () => {
    this.setState({ loading: true });
    setTimeout(() => {
      this.setState({ selectedRowKeys: [], selectedRows: [], loading: false })
    }, 1000);
  }

  onSelectOption = (e: any) => {
    // 1、获取选中设备
    // 2、对选中设备批量操作
    if (!e.key || e.key == "Select") {
      return
    }
    if (this.state.selectAll || this.state.selectedRowKeys.length) {
      this.setState({batchOperationVisible: false});
      switch (e.key) {
        case "Lock":
          if (this.state.searchPlatform === "IOS" || this.state.searchPlatform === "macOS") {
            iosDeviceOperations({
              deviceIds: this.state.selectedRowKeys,
              commandType: 1,
              selectAll: this.state.selectAll,
            }).then(
              () => { notification.success({message: <Translation>{t => {return t("操作成功")}}</Translation>}) },
              () => { notification.error({message: <Translation>{t => {return t("操作失败")}}</Translation>}) },
            )
          }
          else {
            androidDeviceOperations({
              deviceIds: this.state.selectedRowKeys,
              operationType: e.key,
              selectAll: this.state.selectAll,
            }).then(
              () => { notification.success({message: <Translation>{t => {return t("操作成功")}}</Translation>}) },
              () => { notification.error({message: <Translation>{t => {return t("操作失败")}}</Translation>}) },
            )
          }
          break;
        case "EraseDevice":
          this.setState({eraseDeviceVisible: true});
          break;
        case "Clearlock":
          iosDeviceOperations({
            deviceIds: this.state.selectedRowKeys,
            commandType: 57,
            selectAll: this.state.selectAll,
          }).then(
            () => { notification.success({message: <Translation>{t => {return t("操作成功")}}</Translation>}) },
            () => { notification.error({message: <Translation>{t => {return t("操作失败")}}</Translation>}) },
          )
          break;
        case "RestartDevice":
          if (this.state.searchPlatform === "IOS") {
            iosDeviceOperations({
              deviceIds: this.state.selectedRowKeys,
              commandType: 34,
              selectAll: this.state.selectAll
            }).then(
              () => { notification.success({message: <Translation>{t => {return t("操作成功")}}</Translation>}) },
              () => { notification.error({message: <Translation>{t => {return t("操作失败")}}</Translation>}) },
            )
          }
          break;
        case "ShutDownDevice":
          if (this.state.searchPlatform === "IOS") {
            iosDeviceOperations({
              deviceIds: this.state.selectedRowKeys,
              commandType: 35,
              selectAll: this.state.selectAll,
            }).then(
              () => { notification.success({message: <Translation>{t => {return t("操作成功")}}</Translation>}) },
              () => { notification.error({message: <Translation>{t => {return t("操作失败")}}</Translation>}) },
            )
          }
          break;
        case "ClearPasscode":
          if (this.state.searchPlatform === "IOS") {
            iosDeviceOperations({
              deviceIds: this.state.selectedRowKeys,
              commandType: 50,
              selectAll: this.state.selectAll
            }).then(
              () => { notification.success({message: <Translation>{t => {return t("操作成功")}}</Translation>}) },
              () => { notification.error({message: <Translation>{t => {return t("操作失败")}}</Translation>}) },
            )
          }
          break;
        case "Template":
          this.setState({showTemplate: true});
          this.getTemplateList();
          break;
        case "DisEnroll":
          if (this.state.searchPlatform === "IOS" || this.state.searchPlatform === "macOS") {
            iosDeviceOperations({
              deviceIds: this.state.selectedRowKeys,
              commandType: 10,
              selectAll: this.state.selectAll,
            }).then(
              () => { notification.success({message: <Translation>{t => {return t("操作成功")}}</Translation>}) },
              () => { notification.error({message: <Translation>{t => {return t("操作失败")}}</Translation>}) },
            )
          }
          else {
            androidDeviceOperations({
              deviceIds: this.state.selectedRowKeys,
              operationType: e.key,
              selectAll: this.state.selectAll,
            }).then(
              () => { notification.success({message: <Translation>{t => {return t("操作成功")}}</Translation>}) },
              () => { notification.error({message: <Translation>{t => {return t("操作失败")}}</Translation>}) },
            )
          }
          break;
        case "openBluetooth": 
          iosDeviceOperations({
            deviceIds: this.state.selectedRowKeys,
            commandType: 62,
            selectAll: this.state.selectAll,
          }).then(
            () => { notification.success({message: <Translation>{t => {return t("操作成功")}}</Translation>}) },
            () => { notification.error({message: <Translation>{t => {return t("操作失败")}}</Translation>}) },
          ).finally(() => { this.refreshTable() })
          break;
        case "closeBluetooth": 
          iosDeviceOperations({
            deviceIds: this.state.selectedRowKeys,
            commandType: 63,
            selectAll: this.state.selectAll,
          }).then(
            () => { notification.success({message: <Translation>{t => {return t("操作成功")}}</Translation>}) },
            () => { notification.error({message: <Translation>{t => {return t("操作失败")}}</Translation>}) },
          ).finally(() => { this.refreshTable() })
          break;
        case "SyncDevice":
          if (this.state.searchPlatform === "IOS") {
            iosDeviceOperations({
              deviceIds: this.state.selectedRowKeys,
              commandType: 0,
              selectAll: this.state.selectAll,
            }).then(
              () => { notification.success({message: <Translation>{t => {return t("操作成功")}}</Translation>}) },
              () => { notification.error({message: <Translation>{t => {return t("操作失败")}}</Translation>}) },
            ).finally(() => { this.refreshTable() })
          }
          break;
        case "SystemUpdate":
          this.setState({systemUpdateVisible: true});
          break;
        case "LostMode":
          this.setState({isLoseModaVisible: true});
          break;
        case "DisabledLostMode":
          if (this.state.searchPlatform === "IOS") {
            iosDeviceOperations({
              deviceIds: this.state.selectedRowKeys,
              commandType: 9,
              selectAll: this.state.selectAll,
            }).then(
              () => { notification.success({message: <Translation>{t => {return t("操作成功")}}</Translation>}) },
              () => { notification.error({message: <Translation>{t => {return t("操作失败")}}</Translation>}) },
            ).finally(() => { this.refreshTable() })
          }
          break;
        case "Disown": 
          iosDeviceOperations({
            deviceIds: this.state.selectedRowKeys,
            commandType: 180,
            selectAll: this.state.selectAll,
          }).then(
            () => { notification.success({message: <Translation>{t => {return t("操作成功")}}</Translation>}) },
            () => { notification.error({message: <Translation>{t => {return t("操作失败")}}</Translation>}) },
          ).finally(() => { this.refreshTable() })
          break;        
        case "TimeZone": 
          iosDeviceOperations({
            deviceIds: this.state.selectedRowKeys,
            commandType: 360,
            selectAll: this.state.selectAll,
          }).then(
            () => { notification.success({message: <Translation>{t => {return t("操作成功")}}</Translation>}) },
            () => { notification.error({message: <Translation>{t => {return t("操作失败")}}</Translation>}) },
          ).finally(() => { this.refreshTable() })
          break;
        default:
          break;
      }
    }
    else {
      notification.warning({message: <Translation>{t => {return t("未选择任何设备")}}</Translation>})
    } 
  }

  getTemplateList = (value: string="") => {
    getTemplateListAll().then(
      (res) => {
        res = res.filter((item: any) => {
          return item.platform === this.state.searchPlatform && (this.state.searchPlatform === "IOS" || this.state.searchPlatform === "macOS" || this.state.searchPlatform === "Android")
        });
        this.setState({templateList: value ? res.filter((item: any) => { return stringContaint(value, item.name) }) : res});
      }
    )
  }

  onSearchTemplate = (value: string) => {
    this.getTemplateList(value);
  }

  templateRowSelection = () => {
    var that = this;
    return {
      onChange(selectedRowKeys: any, selectedRows: any) {
        that.setState({selectTemplate: selectedRowKeys[0]})
      },
      // onSelect(record: any, selected: any, selectedRows: any) {
      // },
      // onSelectAll(selected: any, selectedRows: any, changeRows: any) {
      // },
    }
  };

  handleTemplateOk = () => {
    appDeviceTemplate(this.state.selectTemplate, {
      deviceIds: this.state.selectedRowKeys,
      templateId: this.state.selectTemplate
    }).then(
      () => {
        this.setState({showTemplate: false, selectedRowKeys: []});
        notification.success({message: <Translation>{t => {return t("应用成功")}}</Translation>});
      },
      () => {
        notification.error({message: <Translation>{t => {return t("应用失败")}}</Translation>});
      }
    )
  }

  uploadFile = (res: any) => {
    const { file } = res;
    this.setState({file: file});
  }

  onEditOk = () => {
    if (!this.state.file) {
      return notification.warning({message: <Translation>{t => {return t("文件不能为空")}}</Translation>})
    }
    this.setState({loading: true});
    batchEditDevices({File: this.state.file}).then(
      () => { notification.success({message: <Translation>{t => {return t("保存成功")}}</Translation>}) },
      () => { notification.error({message: <Translation>{t => {return t("保存失败")}}</Translation>}) }
    ).finally(
      () => { 
        this.setState({loading: false, file: "", isBatchEdit: false});
        this.getList(1);
      }
    )
  }

  downloadData = () => {
    this.setState({loading: true});
    this.formRef.current?.validateFields().then((res) => {
      const { deviceType, searchOrg, searchName, tags } = res;
      if (this.state.selectedMenu === "RecycleBin") {
        exportDevices({
          deviceType: deviceType,
          status: 4,
          platform: this.state.selectedPlatform,
          organizationId: searchOrg,
          search: searchName
        }, tags).then(
          (res) => { 
            let blob = new Blob([res], {type: 'application/vnd.ms-excel'});
            let downloadElement = document.createElement('a');
            let href = window.URL.createObjectURL(blob)
            downloadElement.href = href;
            downloadElement.download = `devices_${dayjs(new Date()).format('YYYYMMDDHHmmss')}.xls`;
            document.body.appendChild(downloadElement);
            downloadElement.click();
            document.body.removeChild(downloadElement);
            window.URL.revokeObjectURL(href);
            notification.success({message: <Translation>{t => {return t("导出成功")}}</Translation>}) 
          },
          () => { notification.error({message: <Translation>{t => {return t("导出失败")}}</Translation>}) },
        ).finally(
          () => { this.setState({loading: false}) }
        )
      } else {
        exportDevices({
          deviceType: deviceType,
          platform: this.state.selectedPlatform,
          organizationId: searchOrg,
          search: searchName
        }, tags).then(
          (res) => { 
            let blob = new Blob([res], {type: 'application/vnd.ms-excel'});
            let downloadElement = document.createElement('a');
            let href = window.URL.createObjectURL(blob)
            downloadElement.href = href;
            downloadElement.download = `devices_${dayjs(new Date()).format('YYYYMMDDHHmmss')}.xls`;
            document.body.appendChild(downloadElement);
            downloadElement.click();
            document.body.removeChild(downloadElement);
            window.URL.revokeObjectURL(href);
            notification.success({message: <Translation>{t => {return t("导出成功")}}</Translation>}) 
          },
          () => { notification.error({message: <Translation>{t => {return t("导出失败")}}</Translation>}) },
        ).finally(
          () => { this.setState({loading: false}) }
        )
      }
    })    
  }

  onTableChange = (pagination: any, filters: any, sorter: any, extra: any) => {
    if(extra.action === 'sort')
    {
        console.log(sorter);
        var sortField = sorter.field === "enrollTime" ? "enrollDate" : sorter.field;
        var sortOrder = sorter.order ? sorter.order.slice(0, -3) : "asc";
        this.setState({
          orderBy: sortField,
          order: sortOrder
        });
        getAccount().then(res => {
          updateDevicesOrders(res.account, { platform: this.state.selectedPlatform, orderBy: sortField, order: sortOrder }).then(() => {
            this.getList(1, 10, null);
          })
        })
    }
    else
    {
        const extras: any = this.formatFilters(filters);
        this.setState({
          orderBy: sorter.order ? (sorter.field === "enrollTime" ? "enrollDate" : sorter.field) : "",
          order: sorter.order ? sorter.order.slice(0, -3) : "",
          extras: extras,
        });
        this.getList(1, 10, extras);
    }
  }

  // onClickPlatform = async (platform: string) => {
  //   this.setState({
  //     searchPlatform: platform,
  //     selectedPlatform: platform,
  //     extras: null,
  //   });
  //   this.formRef.current?.resetFields();
  //   this.getCount(this.state.selectedMenu);
  //   this.getList(1, 10, null);
  // }

  render() {
    const {
      loading,
      data,
      pageSize,
      pageIndex,
      totalCount,
      isDeviceModalvisible,
      tagList,
      tableDropdownVisible,
      tableColumns,
      tableCheckColumes,
      isBatchEdit,
      searchPlatform,
      showTemplate,
      templateList,
      selectedRowKeys,
      selectedPlatform,
      platformCountMapping,
      selectedMenu,
      systemUpdateVisible,
      batchOperationVisible,
      eraseDeviceVisible,
      clearLock,
      tableColumnTem,
      templateColumns,
      isLoseModaVisible
    } = this.state;
    const { orgOptions } = this.props;
    return (
      <Translation>{t => {
        return (
          <div>
            <div className="breadcrumbTop py-2">
              <Breadcrumb>
              
                <Breadcrumb.Item>{t("设备")}</Breadcrumb.Item>
                <Breadcrumb.Item>{t("全部设备")}</Breadcrumb.Item>
              </Breadcrumb>
            </div>

            <Spin spinning={false}>
              <Row style={{ width: "100%" }}>
                {/* <div className="borderBox" style={{padding: 0}}>
                  <Row style={{height: "90px"}}>
                    <Col style={{width: "32%"}} onClick={() => { this.onClickPlatform("IOS") }}>
                      <div style={{display: "flex", justifyContent: "space-between", height: "90px", padding: "10px", border: `${selectedPlatform === "IOS" ? "2px solid #3588F4" : ""}`, overflow: 'hidden'}}>
                        <div style={{width: "70%", display: "flex", zIndex: 1}}>
                          <img src="/images/device-ios.png" alt=""/>
                          <div style={{width: "60%", display: "flex", flexDirection: "column", overflow: "hidden", padding: "0 10px"}}>
                            <Tooltip title={"iOS " + t("平台")}>
                              <span style={{fontSize: 20, fontWeight: 600, color: "#333333", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}>iOS</span>
                            </Tooltip>
                            <Tooltip title={"iPhone+iPad " + t("设备")} placement="bottom">
                              <span style={{fontSize: i18n.language === "zh" ? 14 : 16, fontWeight: 400, color: "#333333", marginTop: 15, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}>iPhone+iPad {t("设备")}</span>
                            </Tooltip>
                          </div>
                        </div>
                        <div style={{display: "flex", flexDirection: "column", overflow: "hidden"}}>
                          <span style={{fontSize: 18, fontWeight: 600, color: "#333333", textAlign: "center", marginTop: 5, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}>{ platformCountMapping["IOS"] }</span>
                          <span style={{fontSize: 14, fontWeight: 400, color: "#333333", textAlign: "center", marginTop: 10, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}>{t("总数")}</span>
                        </div>
                        <img src="/images/iosDevice.png" alt="" style={{width: "100%", position: "absolute", bottom: 0, right: 0}}/>
                        {selectedPlatform === "IOS" && <img src="/images/tri.png" alt="" style={{position: "absolute", bottom: "-10px", left: "50%"}}/>}
                      </div>
                    </Col>
                    <Col style={{backgroundColor: "#F0F2F5", width: "2%"}}></Col>
                    <Col style={{width: "32%"}} onClick={() => { this.onClickPlatform("Android") }}>
                      <div style={{display: "flex", justifyContent: "space-between", height: "90px", padding: "10px", border: `${selectedPlatform === "Android" ? "2px solid #3588F4" : ""}`, overflow: 'hidden'}}>
                        <div style={{width: "70%", display: "flex", zIndex: 1}}>
                          <img src="/images/device-android.png" alt=""/>
                          <div style={{width: "60%", display: "flex", flexDirection: "column", padding: "0 10px", overflow: "hidden"}}>
                            <Tooltip title={"Android " + t("平台")}>
                              <span style={{fontSize: 20, fontWeight: 600, color: "#333333", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}>Android</span>
                            </Tooltip>
                            <Tooltip title={t("手机") + "+" + t("平板") + "+" + t("其它安卓智能设备")} placement="bottom">
                              <span style={{fontSize: i18n.language === "zh" ? 14 : 16, fontWeight: 400, color: "#333333", marginTop: 15, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}>{t("手机")}+{t("平板")}+{t("其它安卓智能设备")}</span>
                            </Tooltip>
                          </div>
                        </div>
                        <div style={{display: "flex", flexDirection: "column", overflow: "hidden"}}>
                          <span style={{fontSize: 18, fontWeight: 600, color: "#333333", textAlign: "center", marginTop: 5, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}>{ platformCountMapping["Android"] }</span>
                          <span style={{fontSize: 14, fontWeight: 400, color: "#333333", textAlign: "center", marginTop: 10, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}>{t("总数")}</span>
                        </div>
                        <img src="/images/androidDevice.png" alt="" style={{width: "100%", position: "absolute", bottom: 0, right: 0}}/>
                        {selectedPlatform === "Android" && <img src="/images/tri.png" alt="" style={{position: "absolute", bottom: "-10px", left: "50%"}}/>}
                      </div>
                    </Col>
                    <Col style={{backgroundColor: "#F0F2F5", width: "2%"}}></Col>
                    <Col style={{width: "32%"}} onClick={() => { this.onClickPlatform("macOS") }}>
                      <div style={{display: "flex", justifyContent: "space-between", height: "90px", padding: "10px", border: `${selectedPlatform === "macOS" ? "2px solid #3588F4" : ""}`, overflow: 'hidden'}}>
                        <div style={{width: "70%", display: "flex", zIndex: 1}}>
                          <img src="/images/device-macos.png" alt=""/>
                          <div style={{width: "60%", display: "flex", flexDirection: "column", overflow: "hidden", padding: "0 10px"}}>
                            <Tooltip title={"macOS " + t("平台")}>
                              <span style={{fontSize: 20, fontWeight: 600, color: "#333333", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}>macOS</span>
                            </Tooltip>
                            <Tooltip title={"MacBook+iMac+Mac " + t("其它设备")} placement="bottom">
                              <span style={{fontSize: i18n.language === "zh" ? 14 : 16, fontWeight: 400, color: "#333333", marginTop: 15, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}>MacBook+iMac+Mac {t("其它设备")}</span>
                            </Tooltip>
                          </div>
                        </div>
                        <div style={{display: "flex", flexDirection: "column", overflow: "hidden"}}>
                          <span style={{fontSize: 18, fontWeight: 600, color: "#333333", textAlign: "center", marginTop: 5, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}>{ platformCountMapping["macOS"] }</span>
                          <span style={{fontSize: 14, fontWeight: 400, color: "#333333", textAlign: "center", marginTop: 10, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}>{t("总数")}</span>
                        </div>
                        <img src="/images/macDevice.png" alt="" style={{width: "100%", position: "absolute", bottom: 0, right: 0}}/>
                        {selectedPlatform === "macOS" && <img src="/images/tri.png" alt="" style={{position: "absolute", bottom: "-10px", left: "50%"}}/>}
                      </div>
                    </Col>
                  </Row>
                </div> */}
                <div className="borderBox">
                  <Menu 
                    mode="horizontal" 
                    selectedKeys={[selectedMenu]} 
                    onClick={async (menu) => {
                      this.setState({
                        selectedMenu: menu.key,
                        extras: null,
                      });
                      this.formRef.current?.resetFields();
                      //this.getCount(menu.key);
                      this.getList(1, 10, null);
                    }}
                    style={{marginBottom: 10, borderBottom: "none"}}
                  >
                    <Menu.Item key="Device">{t("Device")}</Menu.Item>
                    <Menu.Item key="RecycleBin">{t("RecycleBin")}</Menu.Item>
                  </Menu>
                  <Form
                    labelCol={{ span: i18n.language === "zh" ? 6 : "" }}
                    ref={this.formRef}
                  >
                    <Row style={{ width: "100%" }} gutter={[8, 8]} >
                    <Col span={4}>
                        <Form.Item label={t("平台")}  name="platform">
                          <Select
                            allowClear
                            //defaultValue={this.state.selectedPlatform}
                            value={this.state.selectedPlatform}
                            onChange={(v: string) => {
                              this.setState({
                                searchPlatform: v, 
                                selectedPlatform:v,
                                extras: null
                              });
                              //this.getList(1);
                            }}
                          >
                            <Select.Option value="IOS">{t("iOS")}</Select.Option>
                            <Select.Option value="Android">{t("Android")}</Select.Option>
                            <Select.Option value="macOS">{t("macOS")}</Select.Option>
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col span={6}>
                        <Form.Item label={t("设备类型")}  name="deviceType">
                          <Select
                            allowClear
                            placeholder={t("全部设备类型")}
                          >
                            <Select.Option value="0">{t("全部设备类型")}</Select.Option>
                            <Select.Option value="Phone">{t("手机")}</Select.Option>
                            <Select.Option value="PC">{t("电脑")}</Select.Option>
                            <Select.Option value="Pad">{t("平板")}</Select.Option>
                          </Select>
                        </Form.Item>
                      </Col>
                      {/* <Col span={6}>
                        <Form.Item label="平台" name="platform">
                          <Select
                            onChange={(v: string) => {
                              this.setState({searchPlatform: v});
                              this.getList(1);
                            }}
                            allowClear
                            placeholder="全部平台">
                            <Select.Option value="0">全部平台</Select.Option>
                            <Select.Option value="IOS">iOS</Select.Option>
                            <Select.Option value="Android">Android</Select.Option>
                            <Select.Option value="macOS">macOS</Select.Option>
                            <Select.Option value="Windows">Windows</Select.Option>
                          </Select>
                        </Form.Item>
                      </Col> */}
                      {/* <Col span={6}>
                        <Form.Item label={t("部门")} name="searchOrg">
                          <TreeSelect
                            showSearch
                            treeNodeFilterProp="title"
                            treeDefaultExpandAll
                            dropdownStyle={{ maxHeight: 400, minWidth: 100 * (orgOptions.length == 0 ? 2.5 : (orgOptions[0].maxDepth > 8 ? orgOptions[0].maxDepth / 3 : 2.5)), overflow: 'auto' }}
                            placeholder={t("全部")}
                            treeData={orgOptions}
                            allowClear
                          ></TreeSelect>
                        </Form.Item>
                      </Col> */}
                      <Col span={8}>
                        <Form.Item label={t("设备信息")} name="searchName">
                          <Input
                            placeholder={t("输入设备型号、名称、序列号、IMEI、备注")}
                          ></Input>
                        </Form.Item>
                      </Col>
                      <Col span={6}>
                        <Form.Item label={t("设备组")} name="tags">
                          <Select
                            mode="multiple"
                            placeholder={t("请选择设备组")}
                            allowClear
                          >
                            {
                              Array.isArray(tagList) ?
                                tagList.map(item => (
                                  <Select.Option key={item.id} value={item.id} label={item.value}>{item.value}</Select.Option >
                                )) : ""
                            }
                          </Select>
                        </Form.Item>
                      </Col>
                      {selectedMenu === "Device" && <>
                        <Col span={6}>
                          <Form.Item label={t("绑定状态")}  name="status">
                            <Select
                              allowClear
                              placeholder={t("全部")}
                            >
                              <Select.Option value="">{t("全部")}</Select.Option>
                              <Select.Option value="0">{t("未绑定")}</Select.Option>
                              <Select.Option value="1">{t("已绑定")}</Select.Option>
                              {/* <Select.Option value="2">{t("已绑定(待确认)")}</Select.Option> */}
                              <Select.Option value="3">{t("待激活")}</Select.Option>
                            </Select>
                          </Form.Item>
                        </Col>
                      </>}
                      <Col span={6}>
                        <Form.Item wrapperCol={{ offset: 3 }}>
                          <Space size={16}>
                            <Button variant="outlined" onClick={() => { this.onSearchReset(); gaEvent("deviceList", "onClick", "onSearchReset") }}>
                              {t("重置")}
                            </Button>

                            <Button type="primary" onClick={() => { this.onSearch(); gaEvent("deviceList", "onClick", "onSearch") }}>
                              {t("查询")}
                            </Button>
                          </Space>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Form>
                </div>
                <div className="borderBox" style={{overflow: "hidden"}}>
                  <Row>
                    <Col className="ms-auto" style={{ marginBottom: 8 }}>
                      <Space size={16}>
                        {selectedMenu === "Device" && <>
                          <Dropdown
                            dropdownRender={() => (
                              <Menu>
                                <Menu.Item>
                                  <NavLink to="/home/enrollments/androids">
                                    Android {t("设备")}
                                  </NavLink>
                                </Menu.Item>
                                <Menu.Item>
                                  <NavLink to="/home/enrollments/apples">iOS {t("设备")}</NavLink>
                                </Menu.Item>
                              </Menu>
                            )}
                            trigger={['click']}
                          >
                            <Button type="primary">
                            {t("添加设备")} <DownOutlined />
                            </Button>
                          </Dropdown>
                          <Button type="primary" onClick={() => {this.setState({isBatchEdit: true})}}>{t("批量编辑")}</Button>
                          {(searchPlatform && searchPlatform !== "0") && <Dropdown
                            open={batchOperationVisible}
                            onOpenChange={(visible) => { 
                              this.setState({batchOperationVisible: visible})
                            }}
                            dropdownRender={() => (
                              <Menu onClick={(e) => { this.onSelectOption(e); }}>
                                <Menu.Item key='Select'><Checkbox onChange={this.onChange}>{t("全部")}</Checkbox> </Menu.Item>
                                <Menu.Item key='Lock'>{t("锁定设备")}</Menu.Item>
                                {(searchPlatform === 'IOS') && (
                                  <>
                                    <Menu.Item key='SyncDevice'>{t("同步设备")}</Menu.Item>
                                    <Menu.Item key='openBluetooth'>{t("打开蓝牙")}</Menu.Item>
                                    <Menu.Item key='closeBluetooth'>{t("关闭蓝牙")}</Menu.Item>
                                    <Menu.Item key='EraseDevice'>{t("抹除设备")}</Menu.Item>
                                    
                                    {/* <Menu.Item key='RestartDevice'>{t("重启")}</Menu.Item>
                                    <Menu.Item key='ShutDownDevice'>{t("关机")}</Menu.Item> */}
                                    <Menu.Item key='ClearPasscode'>{t("清除锁屏密码")}</Menu.Item>
                                  </>
                                )}
                                {/* <Menu.Item key='Template'>应用配置文件</Menu.Item> */}
                                {(searchPlatform === 'IOS' || searchPlatform === 'macOS') && (<>
                                  <Popconfirm 
                                      title={t("确认重启?")} 
                                      onConfirm={() => { this.onSelectOption({key: 'RestartDevice'}) }}
                                      okText={t("确认")}
                                      cancelText={t("取消")}
                                    >
                                      <Menu.Item key='RestartDevice' className="custom-menu-item">
                                        {t("重启")}
                                      </Menu.Item>
                                  </Popconfirm>
                                  <Popconfirm 
                                    title={t("确认关机?")} 
                                    onConfirm={() => { this.onSelectOption({key: 'ShutDownDevice'}) }}
                                    okText={t("确认")}
                                    cancelText={t("取消")}
                                  >
                                    <Menu.Item key='ShutDownDevice' className="custom-menu-item">
                                      {t("关机")}
                                    </Menu.Item>
                                  </Popconfirm>
                                  <Menu.Item key='SystemUpdate'>{t("系统更新")}</Menu.Item>
                                </>)}
                                <Popconfirm 
                                  title={t("确认解绑此设备?")} 
                                  onConfirm={() => { this.onSelectOption({key: 'DisEnroll'}) }}
                                  okText={t("确认")}
                                  cancelText={t("取消")}
                                >
                                  {(searchPlatform === 'IOS' || searchPlatform === 'macOS' || searchPlatform === 'Android') && <Menu.Item key='DisEnroll' className="custom-menu-item">{t("解绑设备")}</Menu.Item>}
                                </Popconfirm>
                                <Popconfirm 
                                  title={t("确认从ABM/ASM解绑?")} 
                                  onConfirm={() => { this.onSelectOption({key: 'Disown'}) }}
                                  okText={t("确认")}
                                  cancelText={t("取消")}
                                >
                                  {(searchPlatform === 'IOS' || searchPlatform === 'macOS') && <Menu.Item key='Disown' className="custom-menu-item">{t("ABM/ASM解绑")}</Menu.Item>}
                                </Popconfirm>
                                {(searchPlatform === 'IOS' || searchPlatform === 'macOS') && <Menu.Item key='TimeZone'>{t("本地时区")}</Menu.Item>}
                                {searchPlatform === 'IOS' && <>
                                  <Menu.Item key='LostMode'>{t("打开丢失模式")}</Menu.Item>
                                  <Menu.Item key='DisabledLostMode'>{t("关闭丢失模式")}</Menu.Item> 
                                  </>
                                }
                              </Menu>
                            )}
                            trigger={['click']}
                          >
                            <Button type="primary">
                              {t("批量操作")} <DownOutlined />
                            </Button>
                          </Dropdown>}
                        </>}
                        {/* <Button type="text"><UploadOutlined /></Button> */}
                        <div style={{display: "flex"}}>
                          <Button type="text" onClick={this.refreshTable}><ReloadOutlined /></Button>
                          <Dropdown
                            onOpenChange={ (e)=> {this.setState({ tableDropdownVisible: e })}}
                            open={tableDropdownVisible}
                            popupRender={() => (
                              <CheckboxGroup style={{ 
                                backgroundColor: "#fff", 
                                border: "1px solid #FAFAFA", 
                                padding: 6,
                                flexDirection: 'column',
                                maxHeight: '400px',
                                display: 'block',
                                overflowY: 'auto',
                                width: '150px'
                              }} onChange={this.tableColumnsChange} value={tableCheckColumes}>
                                {/* <Row style={{ width: 120 }}> */}
                                  {tableColumnTem?.map((itm: any) => {
                                    if (selectedMenu === "Device" || (selectedMenu === "RecycleBin" && itm.key !== "status")) {
                                      if (searchPlatform === "IOS" && !["isDeviceOwner"].includes(itm.key)) {
                                        //return (<Col key={itm.key} ><Checkbox value={itm.key}>{t(itm.title)}</Checkbox></Col>)
                                        return (<div key={itm.key} style={{ marginBottom: '8px' }}>
                                          <Checkbox value={itm.key}>{t(itm.title)}</Checkbox>
                                        </div>)
                                      }
                                      if (searchPlatform === "Android" && !["singleAppModes","lostModeStatus","bypassCode", "supervisedModel", "isMDMLostModeEnabled", "isSingleAppModeEnabled", "osUpdateStatus", "abmasm", "appleId"].includes(itm.key)) {
                                        return (<div key={itm.key} style={{ marginBottom: '8px'}}>
                                          <Checkbox value={itm.key}>{t(itm.title)}</Checkbox>
                                        </div>)
                                      }
                                      if (searchPlatform === "macOS" && !["singleAppModes","lostModeStatus", "isMDMLostModeEnabled", "isSingleAppModeEnabled", "isDeviceOwner"].includes(itm.key)) {
                                        return (<div key={itm.key} style={{ marginBottom: '8px' }}>
                                          <Checkbox value={itm.key}>{t(itm.title)}</Checkbox>
                                        </div>)
                                      }
                                    }
                                  })}
                                {/* </Row> */}
                              </CheckboxGroup>
                            )}
                          >
                            <Button type="text"><SettingOutlined /></Button>
                          </Dropdown>
                          <Button type="text" onClick={this.downloadData}><DownloadOutlined /></Button>
                        </div>
                      </Space>

                    </Col>
                  </Row>

                  <Table
                    size="middle"
                    scroll={{x: 'max-content'}}
                    loading={loading}
                    dataSource={data}
                    pagination={false}
                    onChange={this.onTableChange}
                    rowKey={record => record.id}
                    columns={tableColumns?.filter(item => {
                      if (selectedMenu === "RecycleBin") {
                        return item.key !== "status"
                      }
                      return item
                    }).map(item => {
                      item.title = t(item.title)
                      return item
                    })}
                    rowSelection={this.rowSelection()}
                    locale={{ emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty> }}
                  >

                  </Table>
                  <Pagination
                    style={{ textAlign: "right", marginTop: "20px" }}
                    pageSize={pageSize}
                    current={pageIndex}
                    total={totalCount}
                    showTotal={(total, range) =>
                      `${range[0]}-${range[1]} / ${total} ${t("条")}`
                    }
                    onChange={(page, pageSize) => {
                      this.getList(page, pageSize);
                    }}
                    onShowSizeChange={(current, size) => this.getList(current, size)}
                  ></Pagination>
                  <span style={{ position: 'absolute', bottom: '10px' }}>
                    {selectedRowKeys.length > 0 ? `Selected ${selectedRowKeys.length} items` : ''}
                  </span>
                </div>
              </Row>
            </Spin>
            <Modal
              confirmLoading={loading}
              maskClosable={false}
              open={isDeviceModalvisible}
              title="添加 Android 设备"
              width={"650px"}
              onOk={() => this.onOk()}
              onCancel={() => this.setState({ isDeviceModalvisible: false })}
            >
              <DeviceForm
                onLoad={(ref) => this.setState({ deviceFormRef: ref })}
              ></DeviceForm>
            </Modal>
            <Modal
              confirmLoading={loading}
              title={t("批量编辑")}
              width={"50%"}
              open={isBatchEdit}
              destroyOnClose={true}
              maskClosable={false}
              onOk={() => {this.onEditOk()}}
              onCancel={() => {this.setState({isBatchEdit: false, file: ""})}}
              okText={t("确认")}
              cancelText={t("取消")}
            >
              <Form style={{lineHeight: "2"}}>
                <b>{t("操作步骤")}</b>
                <div>
                  1.<a className="link" onClick={this.downloadData}>{t("点击这里")}</a>
                  <span>{t("下载设备信息,编辑后进行上传")}</span>
                </div>
                <Form.Item label={t("2.上传编辑后的文件")}>
                  <Upload
                    accept=".xlsx,.xls,.csv"
                    listType="text"
                    showUploadList={true}
                    beforeUpload={() => { return false; }}
                    maxCount={1}
                    onChange={this.uploadFile}
                  >
                    <Button icon={<UploadOutlined />}>{t("上传文件")}</Button>
                  </Upload>
                  {/* <div style={{display: "flex"}}>
                  </div> */}
                </Form.Item>
                <div>
                  <span>{t("注意")}：</span>
                  <p>
                    1. {t("不受监控的设备名称更改将不会反应在设备上。")}<br />
                    2. {t("终端用户、设备组等需要先在系统配置才会生效。")}<br />
                    3. {t("多个设备组用分号隔开，设备组填写例子")} <span>城市:上海;用途:内部,外部</span> <br />
                  </p>
                </div>
              </Form>
            </Modal>
            <Modal
              title="应用配置文件"
              width={700}
              open={showTemplate}
              confirmLoading={loading}
              maskClosable={false}
              destroyOnClose={true}
              onOk={() => {this.handleTemplateOk()}}
              onCancel={() => { this.setState({showTemplate: false}) }}
            >
              <Space direction="vertical" style={{ width: "100%" }}>
                <Row>
                  <Col span={4}>配置文件名称:</Col> 
                  <Col span={18}>   
                    <Input.Search placeholder="输入查询名称" allowClear enterButton="搜索" onSearch={this.onSearchTemplate} />
                  </Col>
                </Row>
                <Row>
                  <Table 
                    columns={templateColumns} 
                    style={{ width: "100%", height: 500 ,overflow:"auto"}} 
                    dataSource={templateList} 
                    rowSelection={{type: 'radio', ...this.templateRowSelection()}} 
                    rowKey={"id"} 
                    locale={{emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty>}}
                  />
                </Row>
              </Space>
            </Modal>
            <Modal
              width={700}
              confirmLoading={loading}
              maskClosable={false}
              destroyOnClose={true}
              title={t("系统更新")}
              open={systemUpdateVisible}
              onOk={() => {
                iosDeviceOperations({
                  deviceIds: this.state.selectedRowKeys,
                  commandType: 72,
                  selectAll: this.state.selectAll
                }).then(
                  () => { notification.success({message: t("操作成功")}) },
                  () => { notification.error({message: t("操作失败")}) },
                ).finally(
                  () => { this.setState({systemUpdateVisible: false});this.refreshTable(); }
                )
              }}
              onCancel={() => { this.setState({systemUpdateVisible: false}) }}
              okText={t("确认")}
              cancelText={t("取消")}
            >
              <p>{t("系统更新将根据设备当前状况下载或安装最新版本的系统。")}</p>
            </Modal>
            <Modal
              width={700}
              confirmLoading={loading}
              maskClosable={false}
              destroyOnClose={true}
              title={t("抹除设备")}
              open={eraseDeviceVisible}
              onOk={() => {
                if (this.state.searchPlatform === "IOS") {
                  iosDeviceOperations({
                    deviceIds: this.state.selectedRowKeys,
                    commandType: 33,
                    selectAll: this.state.selectAll
                  }).then(
                    () => { 
                      notification.success({message: <Translation>{t => {return t("操作成功")}}</Translation>});
                      if (clearLock) { this.onSelectOption({key: "Clearlock"}) } 
                    },
                    () => { notification.error({message: <Translation>{t => {return t("操作失败")}}</Translation>}) },
                  ).finally(
                    () => { this.setState({eraseDeviceVisible: false});this.refreshTable(); }
                  )
                }
              }}
              onCancel={() => { this.setState({eraseDeviceVisible: false}) }}
              okText={t("确认")}
              cancelText={t("取消")}
            >
              <p>{t("抹除设备会将设备恢复至出厂状态,所有数据将被清空。")}</p>
              <div style={{display: "flex", flexDirection: "column"}}>
                <Checkbox value={clearLock} onChange={(e) => { this.setState({clearLock: e.target.checked}) }}>{t("清除激活锁")}</Checkbox>
                <span style={{fontSize: "10px", color: "gray"}}>
                  <b>*</b>{t("勾选将会清除设备的激活锁")}
                </span>
              </div>
            </Modal>
            <Modal
              confirmLoading={loading}
              maskClosable={false}
              title={t("丢失模式")}
              destroyOnClose={true}
              open={isLoseModaVisible}
              onOk={this.handleLoseOk}
              onCancel={() => { this.setState({isLoseModaVisible: false}) }}
              okText={t("确认")}
              cancelText={t("取消")}
            >
              <Form
                layout="horizontal"
                ref={this.lostformRef}
                labelCol={{ span: 6 }}
                initialValues={{ appId: null, packageName: null }}
              >
                <Form.Item rules={[{ required: true }]} label={t("手机号码")} name="phoneNumber">
                  <Input></Input>
                </Form.Item>
                <Form.Item rules={[{ required: true }]} label={t("消息")} name="message">
                  <TextArea rows={4}></TextArea>
                </Form.Item>
              </Form>
            </Modal>
          </div>
        )
      }}</Translation>
    );
  }
}

export default connect(mapStatetoProps, {})(DeviceListPage);
